import {
	ARCHIVE_MEMBER_INFO_FAIL,
	ARCHIVE_MEMBER_INFO_SUCCESS,
	GET_GROUP_INFO_FAIL,
	GET_GROUP_INFO_REQ,
	GET_GROUP_INFO_SUCCESS,
	GET_MEMBER_INFO_FAIL,
	GET_MEMBER_INFO_REQ,
	GET_MEMBER_INFO_SUCCESS,
} from '../constants/groupInfo';

export const leadListReducer = (
	state = { leads: [], groups: [], page: 1, totalPage: 0 },
	action
) => {
	switch (action.type) {
		case GET_GROUP_INFO_REQ:
			return { loading: true };
		case GET_GROUP_INFO_SUCCESS:
			return {
				loading: false,
				leads: action.payload?.leads[0]?.data,
				groups: action.payload?.groups,
				page: action.payload?.leads[0]?.metadata[0]?.page,
				totalPage:
					action.payload?.leads[0]?.metadata[0]?.total %
						action.payload?.leads[0]?.metadata[0]?.limit ===
					0
						? action.payload?.leads[0]?.metadata[0]?.total /
						  action.payload?.leads[0]?.metadata[0]?.limit
						: parseInt(
								action.payload?.leads[0]?.metadata[0]?.total /
									action.payload?.leads[0]?.metadata[0]?.limit
						  ) + 1,
			};
		case GET_GROUP_INFO_FAIL:
			return { loading: false, error: action.payload };

		case ARCHIVE_MEMBER_INFO_SUCCESS:
			return {
				...state,
				loading: false,
				leads:
					state.leads &&
					state.leads.length &&
					state.leads.filter((lead) => lead._id !== action.payload),
			};
		case ARCHIVE_MEMBER_INFO_FAIL:
			return { ...state };

		default:
			return state;
	}
};

export const getLeadReducer = (state = {}, action) => {
	switch (action.type) {
		case GET_MEMBER_INFO_REQ:
			return { loading: true, ...state };
		case GET_MEMBER_INFO_SUCCESS:
			return {
				loading: false,
				lead: action.payload?.lead,
				otherGroups: action.payload?.otherGroups,
			};
		case GET_MEMBER_INFO_FAIL:
			return { loading: false, error: action.payload };

		default:
			return state;
	}
};
